import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
export const useI18n = () => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation('app_pric');
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const brandTranslations = require(`../../../public/locales/${language}/price-pages.json`);
    // Loading new translations in the event of a change of locale
    addTranslations({
        language,
        translations: brandTranslations,
    });
};
